module.exports = __webpack_public_path__ + "static/media/yaseen-overseas.b35f195d.png";